module.exports = __webpack_public_path__ + "b94caac4c88b1fe6c4faf6256646f42e.woff2";